import React from 'react'

interface LoaderProps {
  size?: 'sm' | 'lg' // Optional size prop
  color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light'
  message?: string
}

const Loader: React.FC<LoaderProps> = ({
  size = 'lg',
  color = 'primary',
  message = 'Loading...',
}) => {
  return (
    <div className='d-flex justify-content-center align-items-center py-5'>
      <div className={`spinner-border text-${color} spinner-border-${size}`} role='status'>
        <span className='visually-hidden'>{message}</span>
      </div>
      {message && <p className='ms-2 text-muted'>{message}</p>}
    </div>
  )
}

export default Loader
